import  * as api from  '@/api/effect'
import * as TYPES from './type';

export default {
  // 学生学习进度
  async getlearningProgress({ commit, state }, { paramets, cb }) {
    const result = await api.reqlearningProgress(paramets)
    commit(TYPES.STU_LEARNINGPROGRESS, { result })
    cb && cb()
  },
  // 活动参与率
  async getActivityParticipation({ commit, state }, { paramets, cb }) {
    const result = await api.reqActivityParticipation(paramets)
    commit(TYPES.STU_ACTIVITYTAKE, { result })
    cb && cb()
  },
  // 活动组织次数
  async getActivityTime({ commit, state }, { paramets, cb }) {
    const result = await api.reqActivityTime(paramets)
    commit(TYPES.STU_ACTIVITYTIME, { result })
    cb && cb()
  },
  // 学生考勤预警
  async getAttendanceWarning({ commit, state }, { paramets, cb }) {
    const result = await api.reqAttendanceWarning(paramets)
    commit(TYPES.STU_ATTENDANCE, { result })
    cb && cb()
  },
  // 学生预习预警
  async getPrepareWarning({ commit, state }, { paramets, cb }) {
    const result = await api.reqPrepareWarning(paramets)
    commit(TYPES.STU_PREPAREWARNING, { result })
    cb && cb()
  },
  // 学生作业预警
  async getJobWarning({ commit, state }, { paramets, cb }) {
    const result = await api.reqJobWarning(paramets)
    commit(TYPES.STU_JOBWARNING, { result })
    cb && cb()
  },
  // 学生活动预警
  async getActivityWarning({ commit, state }, { paramets, cb }) {
    const result = await api.reqActivityWarning(paramets)
    commit(TYPES.STU_ACTIVITYWARNING, { result })
    cb && cb()
  },
  // 学生过程性评价
  async getEvaluateList({ commit, state }, { paramets, cb }) {
    const result = await api.reqEvaluateList(paramets)
    commit(TYPES.STU_EVALUATE, { result })
    cb && cb()
  },
  // 学生教学明细表
  async getteachDetail({ commit, state }, { paramets, cb }) {
    const result = await api.reqteachDetail(paramets)
    commit(TYPES.STU_TEACHDETAIL, { result })
    cb && cb()
  },
  // 学生开课时间
  async getheadInformation({ commit, state }, { paramets, cb }) {
    const result = await api.reqheadInformation(paramets)
    commit(TYPES.STU_INFORMATION, { result })
    cb && cb()
  },
}


// WEBPACK FOOTER //
// ./src/store/effect/actions.js